// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__Lr2CT","filesListContainer":"PosDisputesFiles_filesListContainer__2qzD-","filesButton":"PosDisputesFiles_filesButton__osh6B"};